// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"119":"d75ff7b845b8c778","525":"fba5b17fcbe2b36b"}[chunkId] + ".js";
};